const TRANSLATION = {
  common: {
    loading: '로딩 중',
  },
  i18n: {
    English: '영어',
    Spanish: '스페인어',
    Russian: '러시아어',
    'Portuguese (Brazil)': '포르투갈어(브라질)',
    Indonesian: '인도네시아어',
    Czech: '체코어',
    German: '독일어',
    French: '프랑스어',
    Italian: '이탈리아어',
    Dutch: '네덜란드어',
    Polish: '폴란드어',
    Vietnamese: '베트남어',
    Turkish: '터키어',
    Ukrainian: '우크라이나어',
    Chinese: '간체 중국어',
    'Traditional Chinese': '전통 중국어',
    Japanese: '일본어',
    Korean: '한국어',
    Arabic: '아랍어',
    Persian: '페르시아어',
    Thai: '태국어',
    Hindi: '힌디어',
    Malay: '말레이어',
    province: {
      Hebei: '허베이성',
      Shanxi: '산시성',
      Liaoning: '랴오닝성',
      Jilin: '지린성',
      Heilongjiang: '헤이룽장성',
      Jiangsu: '장쑤성',
      Zhejiang: '저장성',
      Anhui: '안후이성',
      Fujian: '푸젠성',
      Jiangxi: '장시성',
      Shandong: '산둥성',
      Henan: '허난성',
      Hubei: '후베이성',
      Hunan: '후난성',
      Guangdong: '광둥성',
      Hainan: '하이난성',
      Sichuan: '쓰촨성',
      Guizhou: '구이저우성',
      Yunan: '윈난성',
      Shaanxi: '산시성(섬서)',
      Gansu: '간쑤성',
      Qinghai: '칭하이성',
      Taiwan: '타이완성',
      Guangxi: '광시 좡족 자치구',
      Neimenggu: '내몽골 자치구',
      Tibet: '티베트 자치구',
      Ningxia: '닝샤 후이족 자치구',
      Xinjiang: '신장 위구르 자치구',
      HongKong: '홍콩 특별행정구',
      Macau: '마카오 특별행정구',
      Beijing: '베이징시',
      Tianjin: '톈진시',
      Shanghai: '상하이시',
      Chongqing: '충칭시',
    },
  },
  pageHeader: {
    product: '제품',
    tvcTest: 'TVC 체험 테스트',
    tvcEval: 'TVC 크리에이티브 평가',
    contactUs: '문의하기',
    Pricing: '가격',
    Dashboard: '지금 시작하기',
    signIn: '로그인',
    signUp: '회원가입',
    resourceCenter: '블로그',
    all: '모두',
    news: '뉴스',
    insight: '인사이트',
    case: '케이스',
  },
  productSwitch: {
    common: {
      comingSoon: '곧 출시',
    },
    modal: {
      heroTitle: '실행할 테스트를 선택해 주세요',
      heroSubtitle:
        'AdEff는 필요할 때마다 다차원적인 크리에이티브 인사이트를 제공할 준비가 되어 있습니다.',
      remainingTimes: '남은 횟수: {{count}}',
      supportedAssets: '지원 소재',
      coreMetrics: '핵심 지표',
      cognitiveNeuroscienceIndicators: '인지-신경 지표',
      consumerAttitudeIndicators: '소비자 태도 지표',
      outputResult: '출력 결과',
      dataReport: '데이터 리포트',
      analysisReport: '분석 리포트',
      accessBackend: '지금 시작하기',
      tabs: {
        tvc: '가로형 크리에이티브 테스트',
        portrait: '세로형 크리에이티브 테스트',
      },
      cards: {
        tvcQuick: {
          title: '가로형-빠른 테스트',
          descriptionHighlight: '데이터 기반 의사결정을 위해 크리에이티브를 신속하게 평가',
        },
        tvcBase: {
          title: '가로형-크리에이티브 진단',
          descriptionHighlight: '크리에이티브 디테일을 정교화하고 실행 가능한 수정 제안을 제공합니다.',
          value1: '10~60초 TVC/OTV 크리에이티브',
          value2: '인지-신경 지표',
        },
        tvcSurvey: {
          title: '가로형-인사이트Pro',
          descriptionHighlight: '다차원 크리에이티브 분석과 전략적 최적화 가이드를 제공합니다.',
          value1: '10~60초 TVC/OTV 크리에이티브',
          value2: '인지-신경 지표',
        },
        portraitQuick: {
          title: '세로형-빠른 테스트',
          descriptionHighlight: '데이터 기반 의사결정을 위해 크리에이티브를 신속하게 평가',
        },
        portraitBase: {
          title: '세로형-크리에이티브 진단',
          descriptionHighlight: '크리에이티브 디테일을 정교화하고 실행 가능한 수정 제안을 제공합니다.',
          value1: '5~90초 세로형 크리에이티브',
          value2: '인지-신경 지표',
        },
        portraitSurvey: {
          title: '세로형-인사이트Pro',
          descriptionHighlight: '다차원 크리에이티브 분석과 전략적 최적화 가이드를 제공합니다.',
          value1: '5~90초 세로형 크리에이티브',
          value2: '인지-신경 지표',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: '가로형 크리에이티브 테스트',
          assetText: '10-60초 TVC/OTV 크리에이티브에 적합',
        },
        portrait: {
          bannerTitle: '세로형 크리에이티브 테스트',
          assetText: '5-90초 세로형 크리에이티브에 적합',
        },
      },
      items: {
        tvcQuick: {
          description: '크리에이티브를 빠르게 비교하고 결정',
        },
        tvcBase: {
          title: '크리에이티브 진단',
          description: '초 단위 최적화로 크리에이티브를 정교화합니다',
        },
        tvcSurvey: {
          title: '심층 인사이트',
          description: '종합 분석으로 문제 지점을 정확히 파악합니다',
        },
        portraitBase: {
          title: '크리에이티브 진단',
          description: '초 단위 최적화로 크리에이티브를 정교화합니다',
        },
        portraitQuick: {
          description: '크리에이티브를 빠르게 비교하고 결정',
        },
        portraitSurvey: {
          title: '심층 인사이트',
          description: '종합 분석으로 문제 지점을 정확히 파악합니다',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: '쿠키 사용에 대한 안내',
    desc: '당사는 웹사이트의 정상적인 작동을 보장하기 위해 필요한 쿠키를 사용합니다. 귀하의 동의 하에 분석 쿠키를 사용하여 사용자 경험을 향상시킵니다. 개인정보처리방침에서 쿠키 정책을 확인하세요.',
    btn1: '모두 거부',
    btn2: '모두 수락',
    cookiePolicy: '쿠키 정책',
  },
  landing: {
    banner: {
      text1: 'AI 기반',
      text2: '광고',
      text3: '테스트',
      text4: '크리에이티브 테스트 및 최적화 플랫폼',
      feature1: '콘텐츠 디코딩',
      feature2: '피드백 예측',
      feature3: '데이터 통합',
      feature4: '결론 추론',
      btn1: '데모 받기',
      btn2: '프로젝트 생성',
    },
    info: {
      title:
        '초그래프 다중 모달 대언어 모델(HMLLM)*에 기반하여 크리에이티브 효과 예측을 신속하게 실현하고 광고 투자 수익을 향상시킵니다',
      subTitle: '*이 모델은 대량의 신경 마케팅 테스트와 다중 에이전트 구축에 기반합니다',
      detail1: '신속한 광고 테스트',
      detail1Desc:
        'AdEff는 15분 이내에 타겟 오디언스의 주의 곡선, 감정 변동 및 크리에이티브 콘텐츠에 대한 참여를 얻고, 상세한 평가 보고서와 최적화 가이드를 제공합니다.',
      detail2: '최적의 크리에이티브 신속 선택',
      detail2Desc:
        'AdEff는 여러 크리에이티브를 동시에 측정하여 브랜드가 신속한 의사 결정을 내릴 수 있도록 지원합니다. 상세한 비교 분석도 제공합니다.',
      detail3: '원클릭으로 다양한 효과적인 버전 생성',
      detail3Desc:
        'AdEff는 원클릭으로 다양한 효과적인 버전을 신속하게 생성하여 여러 전파 장면에 적용할 수 있습니다.',
    },
    advantages: {
      title: 'AdEff의 장점',
      item1Title: '신속한 응답',
      item1Desc: '최단 <tmp>15분</tmp> 내에 보고서를 받을 수 있습니다.',
      item2Title: '독창적인 AI 모델',
      item2Desc: '독창적인 오디언스 피드백에 기반한 <tmp>AI 모델</tmp>.',
      item3Title: '시각화 그래프',
      item3Desc: '<tmp>시각화 그래프</tmp> + AI 해석으로 테스트 보고서를 원클릭으로 생성합니다.',
      item4Title: '방대한 데이터 범위',
      item4Desc: '<tmp>50,000+</tmp> 크리에이티브 데이터베이스',
      item5Title: '전문 팀',
      item5Desc: '<tmp>전문 팀</tmp>이 지원과 가이드를 제공합니다.',
    },
    service: {
      title: 'AdEff 서비스 방식',
      desc: '필요한 서비스 방식을 선택하세요',
      topTitle: '온라인 셀프 서비스',
      topRow1: '자율적으로 프로젝트를 생성하고 테스트를 완료',
      topRow2: '시각화 그래프 + AI 해석 보고서',
      topRow3: '객관적 신경 과학 지표 분석(시선 + 뇌파)',
      topRow4: '독창적인 AI 모델 테스트',
      bottomTitle: '전문 팀 서비스',
      bottomRow1: '전문가가 프로젝트를 생성하고 테스트를 완료',
      bottomRow2: '객관적 신경 과학 지표 분석(시선 + 뇌파), 주관적 지표 추가 옵션',
      bottomRow3: '시각화 그래프 + 전문가 해석 보고서',
      bottomRow4: '독창적인 AI 모델 테스트, 옵션으로 실제 샘플 테스트',
    },
    footer: {
      title:
        'AdEff는 초그래프 다중 모달 대언어 모델(HMLLM)에 기반하여 초그래프를 통해 시각 요소 EEG 신호와 시선 추적 데이터 간의 복잡한 관계를 구축하여 광고 크리에이티브의 신속한 테스트를 실현합니다',
      email: '이메일',
      belongDesc: '<tmp>명략과학기술</tmp>의 제품',
    },
    startBtn: '지금 시작하기',
  },
  contact: { title: '문의하기', copy: '복사', message: { success: '복사 성공' } },
  pricing: {
    title: 'AI 기반 창의성 테스트 및 최적화 전문가',
    starter: {
      title: '스타터',
      desc_1: '일회성 테스트에 적합하며, 구매 후 즉시 사용 가능',
      desc_2: '소규모 테스트에 적합하며, 구매 후 즉시 사용 가능',
      timesDesc: '<strong>{{count}}</strong>회 테스트',
      timesDesc1: '<strong>{{count}}</strong>회 테스트',
      discount: '50% 할인',
      originPrice: '원가',
      desc2: '오디언스 피드백에 기반한 강력한 AI 모델',
      desc3: '신속한 응답은 단 15분',
      desc4: '시각화 그래프',
      desc5: 'AI 해석',
      desc6: '참고 데이터베이스',
      cardDesc1: '기간 한정 할인, {{pricePerTest}}부터',
      cardDesc2: '테스트 횟수는 영구 유효',
    },
    premium: {
      time: '회',
    },
    unlimited: {
      title: '무제한',
      cardDesc1: '{{pricePerTest}}부터',
      cardDesc2: '횟수 유효기간 1년',
      cardDesc3: '맞춤형 전용 벤치마크',
      planDesc500: '연간 500회 테스트 이용 가능',
      planDesc1000: '연간 1,000회 테스트 이용 가능',
    },
    benefits: {
      title: '왜 AdEff를 선택해야 할까요?',
      subtitle: 'AdEff를 구매하면 다음 혜택을 받을 수 있습니다:',
      expertSupport: '전문가 팀의 지원 및 가이드',
      moreNeedsTitle: '다른 구매 요구가 있으신가요?',
      customPlanPrefix: '유연하고 맞춤형 플랜을 지원합니다 — 문의처',
      customPlanSuffix: '에서 전용 솔루션을 받아보세요',
    },
    subscribeBtn: '지금 구독하기',
    contactUs: '문의하기',
  },
  login: {
    loginText: '로그인',
    signUpText: '<tmp>회원가입</tmp> 무료',
    text1: '팀에 참여하세요',
    text1Desc:
      'AdEff는 HMLLM을 기반으로 초그래프 관계를 구축하여 빠른 광고 크리에이티브 테스트를 실현합니다',
    text2: '사용자가 회사에 참여했습니다',
    text3: '팀 초대가 만료되었습니다',
    text4: '팀 초대 링크가 유효하지 않습니다.',
    optionText1: '이미 계정이 있습니까?',
    optionText2: '계정이 없습니까?',
    alertText1: '등록함으로써 동의합니다',
    alertText2: '동의합니다',
    termsOfService: '서비스 약관',
    privacy: '개인정보 처리방침',
    privacyTips: '가입하기 전에 동의란을 확인해 주세요.',
    and: '및',
    or: '또는',
    next: '다음',
    googleLogin: 'Google로 로그인',
    googleSignUp: 'Google로 회원가입',
    loginWithEmail: '이메일로 로그인',
    signUpWithEmail: '이메일로 회원가입',
    password: '비밀번호',
    emailAddress: '이메일 주소',
    enterEmail: '이메일 주소를 입력하세요',
    enterPassword: '비밀번호 입력',
    confirmPassword: '비밀번호 확인',
    forgotPassword: '비밀번호 찾기',
    inconsistentPassword: '비밀번호가 일치하지 않습니다',
    verificationCode: '인증 코드',
    emptyVerificationCode: '인증 코드는 비워둘 수 없습니다',
    enterVerificationCode: '인증 코드를 입력하세요',
    sendedVerificationCode: '인증 코드가 귀하의 이메일로 전송되었습니다',
    emailOrPasswordNotCorrect: '이메일 또는 비밀번호가 올바르지 않습니다.',
    message: {
      text1: '입력 내용이 유효하지 않습니다',
      text2: '이메일 주소가 이미 등록되어 있습니다',
      text3: '인증 코드 검증 오류!',
      text4: '이 계정은 기업에 바인딩되어 있지 않습니다. 다시 바인딩하세요!',
      text5: '올바른 이메일 형식을 입력하세요',
      text6: '비밀번호는 최소 12자 이상이어야 합니다',
      text7: '비밀번호는 대문자, 소문자, 숫자를 포함해야 합니다',
      requestLimit: '요청 제한을 초과했습니다. 나중에 다시 시도하세요.',
    },
  },
  resetPwdPage: {
    submit: '제출',
    emailNotFound: '이메일을 확인하세요',
    emailHasSent: '이메일이 {{email}}로 전송되었습니다',
    checkYourInbox: '이메일을 확인하세요',
    resetYourPassword: '비밀번호 재설정',
    resetLinkHasSent: '비밀번호 재설정 링크가 귀하의 계정에 연결된 이메일로 전송되었습니다',
    enterYourEmailAddress: '이메일 주소를 입력하세요',
    didNotGetEmail: '이메일을 받지 못했습니까?',
    tryAgain: '다시 시도하세요',
    goBackToSign: '로그인 페이지로 돌아가기',
    email: '이메일',
    enterYourEmail: '이메일 주소를 입력하세요',
    resetPassword: '비밀번호 재설정',
    resetPwdSuccess: '비밀번호가 성공적으로 재설정되었습니다',
    message: {
      resetLinkCodeError: '링크의 코드가 유효하지 않습니다',
      requestLimit: '요청 제한을 초과했습니다. 나중에 다시 시도하세요.',
    },
  },
  memberRequestPage: {
    title: '멤버 요청 확인',
    subTitle: '요청 출처:',
    deny: '거부',
    approve: '승인',
    teamFull: '팀이 가득 찼습니다',
    yourTeamIsFull: '귀하의 팀은 가득 찼습니다. 추가 멤버를 얻으려면 문의하세요.',
    manageMembers: 'AdEff에서 멤버 관리',
    requestApproved: '요청이 승인되었습니다',
    approvedDesc:
      '귀하는 <tmp>{{name}}</tmp>가 귀하의 팀에 참여하는 것을 승인했습니다. 알림 이메일이 자동으로 전송되었습니다.',
    requestDeclined: '요청이 거부되었습니다',
    declinedDesc:
      '귀하는 <tmp>{{name}}</tmp>가 귀하의 팀에 참여하는 것을 거부했습니다. 알림 이메일이 자동으로 전송되었습니다.',
  },
  infoBindPage: {
    title: 'AI 기반 광고 테스트',
    desc: '초그래프 다중 모달 대언어 모델(HMLLM)*에 기반하여 크리에이티브 효과 예측을 신속하게 실현하고 광고 투자 수익을 향상시킵니다',
    joinAdEff: 'AdEff에 참여하여 새로운 여정을 시작하세요',
    advantages: {
      title1: '더 강력하게',
      desc1: '방대한 데이터베이스에 기반한 독창적인 AI 모델',
      title2: '더 경제적으로',
      desc2: '전통적인 방법의 10% 가격으로',
      title3: '더 빠르게',
      desc3: '최단 15분 내에 보고서를 받습니다',
      title4: '더 전문적으로',
      desc4: '24/7 서비스 지원 및 전문가 팀 서비스 제공',
    },
    username: '사용자 이름',
    company: '회사',
    placeOfResidence: '국가/지역',
    invitationCode: '추천 코드',
    createAccountForFree: '무료로 계정 생성',
    refreshStatus: '상태 새로 고침',
    reapply: '재신청',
    bySigningUp: '등록함으로써 동의합니다',
    termsOfService: '서비스 약관',
    and: '및',
    privacyPolicy: '개인정보 처리방침',
    message: {
      success: '계정 생성 요청이 전송되었습니다. 잠시 기다려 주세요!',
      success2: '계정이 성공적으로 생성되었습니다',
      error: '계정 생성에 실패했습니다. 나중에 다시 시도하세요.',
      accountCreatedDirectly: '계정이 직접 생성되었습니다!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        '요청이 승인되었으며 페이지가 자동으로 이동합니다.',
      theRequestHasBeenSendAndPleaseBePatient: '요청이 전송되었습니다. 잠시 기다려 주세요!',
      wrongRouting: '라우팅 오류, 페이지가 자동으로 이동합니다.',
      yourRequestHasBeenDeclined:
        '귀하의 요청이 거부되었습니다. 팀에 재신청하거나 초대 코드 없이 새 계정을 생성하세요.',
      waitingForAdministratorReview: '관리자의 검토를 기다리고 있습니다',
      thisFieldIsRequired: '이 필드는 필수입니다',
      pleaseEnterTheResidence: '국가를 입력하세요',
      invitationCodeDoesNotExist: '유효하지 않은 추천 코드입니다',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        '에이전트 추천을 통해 이용하시는 경우 추천 코드를 입력해 주세요',
      pleaseEnterTheUsername: '사용자 이름을 입력하세요',
      pleaseEnterTheCompanyName: '회사 이름을 입력하세요',
      needRegisterAgain: '작업 오류, 다시 등록하세요',
      alreadyBind: '이미 회사에 바인딩되어 있습니다. 다시 바인딩하지 마세요',
    },
  },
  knowledgeFormPage: {
    name: '이름',
    email: '이메일',
    companyName: '회사명',
    department: '부서',
    role: '직책',
    country: '국가',
    province: '도/성',
    pleaseEnter: '입력해 주세요',
    pleaseSelect: '선택해 주세요',
    pleaseEnterTheName: '이름을 입력해 주세요',
    pleaseEnterTheEmail: '이메일을 입력해 주세요',
    pleaseEnterValidEmail: '유효한 이메일을 입력해 주세요',
    pleaseEnterTheCompanyName: '회사명을 입력해 주세요',
    pleaseSelectTheDepartment: '부서를 선택해 주세요',
    pleaseSelectTheRole: '직책을 선택해 주세요',
    pleaseSelectTheCountry: '국가를 선택해 주세요',
    pleaseSelectTheProvince: '도/성을 선택해 주세요',
    textIsRequired: '이 항목은 필수입니다',
    submit: '제출',
    download: '다운로드',
    submitSuccess: '제출 성공',
    downloadSuccess: '다운로드 성공',
    title1: '정보를 입력하시면 자료를 받으실 수 있습니다',
    title2: '다운로드할 자료를 선택해 주세요',
  },
  dashboard: {
    pdf: {
      downloadReport: '보고서 다운로드',
      downloadBtnText: 'PDF 다운로드',
      content: '콘텐츠',
      theEnd: '끝',
      thankYouForWatching: '감사합니다.',
      pdfProcessing: 'PDF 처리 중...',
      pdfProcessingDesc: 'PDF 페이지 수: {{count}}，예상 {{seconds}} 초，저장 후 대기',
      pdfProcessingDesc2: '현재 언어 버전이 번역되지 않았습니다. PDF를 생성할 수 없습니다.',
    },
    ppt: {
      downloadBtnText: 'PPT 다운로드',
      pptProcessingDesc: 'PPT 파일 생성 중이니 잠시만 기다려 주세요',
      pptProcessingDesc2: '현재 언어 버전이 번역되지 않아 PPT를 생성할 수 없습니다',
      pptProcessingDesc3: 'PPT 파일 다운로드 중입니다, 잠시만 기다려 주세요...',
      translateCompleted: 'PPT 번역 완료',
      exportSuccess: 'PPT 파일 내보내기 성공',
      exportFailed: 'PPT 파일 내보내기 실패',
    },
    layout: {
      projectMenuText: '광고 테스트 프로젝트',
      accountManagementText: '계정 관리',
      myAccountText: '내 계정',
      subscriptionText: '구독',
      logout: '로그아웃',
      dataDetails: '데이터 세부 정보',
      dataAnalysis: '데이터 분석',
      dataOverview: '데이터 개요',
      dataComparison: '데이터 비교',
    },
    systemMessage: {
      title: '시스템 메시지',
      task: '작업',
      system: '시스템',
      noRelevantContent: '관련 콘텐츠를 찾을 수 없습니다',
      noMore: '더 이상 메시지가 없습니다',
    },
    projectPage: {
      createProject: '프로젝트 생성',
      searchPlaceholder: '프로젝트/광고/브랜드 이름을 입력하여 검색',
      sortLabel: '광고 효과 지수 정렬',
      sortPlaceholder: '정렬 방법을 선택하세요',
      sortOption1: '효과 지수 오름차순',
      sortOption2: '효과 지수 내림차순',
      filterSort: '필터 및 정렬',
      filterBenchmarkTitle: '벤치마크 필터',
      sortTitle: '정렬',
      tabAllCreative: '전체 크리에이티브({{count}})',
      tabGeneralCreative: '일반 크리에이티브({{count}})',
      tabSplashCreative: '스플래시 크리에이티브({{count}})',
      generalCreativeLabel: '일반 크리에이티브',
      splashCreativeLabel: '스플래시 크리에이티브',
      normTypePlaceholder: '기준값 유형을 선택하세요',
      totalDesc: '광고 프로젝트 (총 {{total}}개)',
      noRelevantContent: '관련 콘텐츠를 찾을 수 없습니다',
      loadMore: '더 불러오기',
      projectCard: { delete: '삭제', reanalyze: '재분석', download: '다운로드' },
      delete: '삭제',
      cancel: '취소',
      message: {
        deleteTitle: '삭제 알림',
        delete:
          '이 프로젝트를 삭제하면 모든 관련 데이터에 접근할 수 없게 됩니다. 계속하시겠습니까?',
        delete1:
          '이 프로젝트는 무료 테스트 프로젝트이며, 삭제하면 무료 테스트 기회를 되돌릴 수 없습니다.',
        delete2:
          '이 프로젝트는 아직 분석을 시작하지 않았습니다. 삭제 후 테스트 크레딧이 환불됩니다',
        deleteSuccess: '삭제 성공!',
        analysisCountNotEnough: '분석 횟수가 부족합니다. 다시 충전 후 다시 시도하세요.',
        analysisFailed: '분석에 실패했습니다. 나중에 다시 시도하세요.',
        waitingQuestion:
          '최대 3개의 프로젝트를 동시에 분석할 수 있습니다. 이 프로젝트는 대기 큐에 들어갔으며, 곧 자동으로 분석을 시작합니다.',
        landscapeQuickCompleted: '가로형-퀵 테스트 프로젝트가 완료되었습니다',
        portraitQuickCompleted: '세로형-퀵 테스트 프로젝트가 완료되었습니다',
        landscapeSurveyCompleted: '가로형-심층 인사이트 프로젝트가 완료되었습니다',
        portraitSurveyCompleted: '세로형-심층 인사이트 프로젝트가 완료되었습니다',
      },
    },
    projectCreatePage: {
      createProject: '프로젝트 생성',
      basicInformation: '기본 정보',
      projectType: '프로젝트 유형',
      projectName: '프로젝트 이름',
      categoryType: '산업',
      brandName: '브랜드 이름',
      advertisingInformation: '광고 정보',
      adName: '광고 이름',
      norm: '기준값',
      targetMarketNorm: '타겟 시장 기준값',
      brandNorm: '브랜드 기준값',
      taGender: 'TA 성별',
      targetMarket: '타겟 시장',
      taAge: 'TA 나이',
      next: '다음',
      previous: '이전',
      confirmOrder: '주문 확인',
      estTime: '예상 시간',
      minutes: '분',
      consumption: '이번 주문 소비',
      testPoint: '테스트 횟수',
      remaining: '남은',
      times: '회',
      type: '유형',
      purchase: '구매',
      outputLanguage: '출력 언어',
      durationCategory: '크리에이티브 유형',
      durationCategoryDesc: '분석 지표는 크리에이티브 유형에 따라 달라집니다. 콘텐츠에 가장 적합한 옵션을 선택해 주세요.',
      durationCategoryOptions: {
        tenPlus: '일반 크리에이티브(10초+)',
        fiveToTen: '오프닝 크리에이티브(5-10초)',
      },
      adSelection: {
        adCreativeTest: '광고 크리에이티브 테스트',
        adCreativeTestDesc:
          '단일 광고 크리에이티브의 오디언스 피드백을 테스트하고 분석 및 제안을 제공합니다',
        adCreativeSelection: '광고 크리에이티브 선택',
        adCreativeSelectionDesc:
          '여러 광고 크리에이티브의 피드백 효과를 비교하고 종합적으로 선택합니다',
        adCreativeEditing: '광고 크리에이티브 편집',
        adCreativeEditingDesc: 'AI가 광고 크리에이티브의 중요한 부분을 자동으로 생성합니다',
        launchingSoon: '곧 출시',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: '식품/음료 산업',
        packagedFood: '포장 식품',
        confectionery: '과자/젤리',
        frozenMeals: '냉동 음식',
        fastFood: '패스트푸드',
        beverage: '음료',
        alcohol: '알코올',
        dairy: '유제품',
        grainAndSeasoning: '곡물/조미료',
        beverageMixes: '음료 혼합물',
        freshProduce: '신선 식품',
        otherFoodAndBeverage: '기타 식품/음료',
        /**----------------------- */
        consumerElectronicsCategory: '소비자 전자 제품',
        mobilePhone: '휴대폰',
        computer: '컴퓨터',
        smartDevice: '스마트 기기',
        phoneAccessories: '휴대폰 액세서리',
        computerAccessories: '컴퓨터 액세서리',
        software: '소프트웨어',
        camera: '카메라',
        officeSupplies: '사무용품',
        otherConsumerElectronics: '기타 소비자 전자 제품',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: '제약/건강 산업',
        otcMedicine: 'OTC 의약품',
        prescriptionDrugs: '처방 의약품',
        healthSupplements: '건강 보조제',
        pharmaceuticalCompanies: '제약 회사',
        medicalDevices: '의료 기기',
        medicalServices: '의료 서비스',
        pharmacy: '약국',
        otherPharmaceuticalsAndHealthCare: '기타 제약/건강',
        /**----------------------- */
        beautyAndPersonalCareCategory: '뷰티/개인 케어',
        hairCare: '머리 관리',
        womenSkincare: '여성 피부 관리',
        homeCleaning: '가정 청소',
        bodyCare: '몸 관리',
        feminineCare: '여성 건강',
        oralCare: '구강 관리',
        menSkincare: '남성 피부 관리',
        makeup: '메이크업',
        fragrances: '향수',
        beautyServices: '뷰티 서비스',
        otherBeautyAndPersonalCare: '기타 뷰티/개인 케어',
        /**----------------------- */
        maternalAndInfantProductsCategory: '양육/유아 제품',
        babyFood: '유아 식품',
        babyCareEssentials: '유아 필수품',
        babyToys: '유아 장난감',
        otherMaternalAndInfantProducts: '기타 양육/유아 제품',
        /**----------------------- */
        networkAndCommunicationCategory: '네트워크/통신',
        mobileCarriers: '휴대폰 운영사',
        internetProviders: '인터넷 제공사',
        telecomEquipment: '통신 장비',
        otherNetworkAndCommunication: '기타 네트워크/통신',
        /**----------------------- */
        travelAndAccommodationCategory: '여행/숙박',
        localTourism: '관광/지역',
        bookingPlatform: '예약 플랫폼',
        hotels: '호텔',
        airlines: '항공사',
        airport: '공항',
        otherTravelAndAccommodation: '기타 여행/숙박',
        /**----------------------- */
        vehiclesCategory: '차량 산업',
        motorVehicleProductsAndServices: '자동차 제품/서비스',
        carBrands: '자동차 브랜드',
        dealerships: '딜러쉽',
        carFinance: '자동차 금융',
        evCar: '전기 자동차',
        motorcycle: '오토바이',
        onlineUsedCarMarketplace: '중고차 온라인 거래 플랫폼',
        carRentalPlatform: '자동차 렌트 플랫폼',
        travelNavigation: '여행 내비게이션',
        bicycle: '자전거',
        otherVehicles: '기타 차량',
        /**----------------------- */
        householdAppliancesCategory: '가정용 가전제품',
        majorAppliances: '대형 가전제품',
        healthAndPersonalCareAppliances: '건강/개인 케어 가전제품',
        majorKitchenAndBathAppliances: '대형 주방 가전제품',
        smallKitchenAppliances: '소형 주방 가전제품',
        environmentalAppliances: '환경 가전제품',
        cleaningAppliances: '청소 가전제품',
        otherHouseholdAppliances: '기타 가정용 가전제품',
        /**----------------------- */
        retailAndServiceCategory: '소매/서비스 산업',
        onlineRetailEcommerce: '온라인 소매/전자상거래',
        departmentStores: '대형 매장',
        lifeServices: '생활 서비스',
        retailServicesAndDelivery: '소매 서비스/배송',
        supermarkets: '슈퍼마켓',
        otherRetailAndService: '기타 소매/서비스',
        /**----------------------- */
        apparelCategory: '의류/액세서리',
        footwear: '신발',
        clothing: '의류',
        watchesWatchRetail: '시계/시계 매장',
        jewelry: '보석',
        bags: '가방',
        eyewearOpticalStores: '안경/안경점',
        otherClothingAndAccessories: '기타 의류/액세서리',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: '건축/인테리어',
        homeFurnishing: '가구',
        homeImprovement: '건축',
        otherHomeImprovementAndFurnishings: '기타 건축/인테리어',
        /**----------------------- */
        financialAndInsuranceCategory: '금융/보험',
        bank: '은행',
        fintech: '금융 기술',
        investmentAndFinancialServices: '금융 서비스',
        insurance: '보험',
        otherFinancialAndInsurance: '기타 금융/보험',
        /**----------------------- */
        entertainmentAndLeisureCategory: '엔터테인먼트/레저',
        socialApp: '소셜 앱',
        toysAndDolls: '장난감/인형',
        concerts: '콘서트',
        events: '이벤트',
        movies: '영화',
        themeParks: '테마 파크',
        gambling: '게임',
        onlineGaming: '온라인 게임',
        tvChannels: 'TV 채널',
        otherEntertainmentAndLeisure: '기타 엔터테인먼트/레저',
        /**----------------------- */
        industrialAndAgriculturalCategory: '산업/농업',
        industrialSupplies: '산업 자재',
        agriculturalSupplies: '농업 자재',
        otherIndustrialAndAgricultural: '기타 산업/농업',
        /**----------------------- */
        petLifeCategory: '애완동물 산업',
        petFood: '애완동물 식품',
        petSupplies: '애완동물 용품',
        otherPetLife: '기타 애완동물',
        /**----------------------- */
        educationAndLearningCategory: '교육/학습 산업',
        onlineLearning: '온라인 교육',
        schools: '학교',
        skillCourses: '기술 과정',
        tutoring: '튜터링',
        universities: '대학',
        otherEducationAndLearning: '기타 교육/학습',
        /**----------------------- */
        communityAndPublicServiceCategory: '커뮤니티/공공 서비스',
        charityCampaigns: '자선 캠페인',
        ngoAds: 'NGO 광고',
        otherCommunityAndPublicService: '기타 커뮤니티/공공 서비스',
        /**----------------------- */
        otherCategory: '기타',
        governmentAdvertising: '정부 광고',
        realEstateAdvertising: '부동산 광고',
        otherAdvertising: '기타 광고',
      },
      genderSelect: {
        male: '남성',
        female: '여성',
        all: '모두',
      },
      targetMarketSelect: {
        China: '중국',
        HongKongChina: '홍콩, 중국',
        MacauChina: '마카오, 중국',
        TaiwanChina: '대만, 중국',
        Japan: '일본',
        Korea: '한국',
        Mongolia: '몽골',
        Singapore: '싱가포르',
        Thailand: '태국',
        Vietnam: '베트남',
        Malaysia: '말레이시아',
        Philippines: '필리핀',
        Indonesia: '인도네시아',
        Cambodia: '캄보디아',
        Laos: '라오스',
        India: '인도',
        SaudiArabia: '사우디아라비아',
        Turkey: '터키',
        Israel: '이스라엘',
        UnitedArabEmirates: '아랍에미리트',
        Qatar: '카타르',
        Kuwait: '쿠웨이트',
        UnitedKingdom: '영국',
        France: '프랑스',
        Germany: '독일',
        Netherlands: '네덜란드',
        Belgium: '벨기에',
        Austria: '오스트리아',
        Italy: '이탈리아',
        Spain: '스페인',
        Portugal: '포르투갈',
        Greece: '그리스',
        Sweden: '스웨덴',
        Norway: '노르웨이',
        Finland: '핀란드',
        Denmark: '덴마크',
        Estonia: '에스토니아',
        Latvia: '라트비아',
        Russia: '러시아',
        Poland: '폴란드',
        CzechRepublic: '체코',
        Hungary: '헝가리',
        Romania: '루마니아',
        Bulgaria: '불가리아',
        Slovakia: '슬로바키아',
        Slovenia: '슬로베니아',
        Ukraine: '우크라이나',
        UnitedStates: '미국',
        Canada: '캐나다',
        Mexico: '멕시코',
        Brazil: '브라질',
        LatinAmerica: '라틴 아메리카',
        Australia: '호주',
        NewZealand: '뉴질랜드',
        Other: '기타',
      },
      languageSelect: {
        english: '영어',
        chinese: '중국어',
        japanese: '일본어',
        korean: '한국어',
        french: '프랑스어',
        traditionalChinese: '전통 중국어',
      },
      placeholder: {
        projectName: '프로젝트 이름을 입력하세요',
        category: '카테고리를 선택하세요',
        brandName: '브랜드 이름을 입력하세요',
        adName: '광고 이름을 입력하세요',
        norm: '기준값을 선택하세요',
        taGender: '성별을 선택하세요',
        targetMarket: '타겟 시장을 선택하세요',
        taAge: '나이를 선택하세요',
        lowerLimit: '하한',
        upperLimit: '상한',
        outputLanguage: '출력 언어를 선택하세요',
      },
      step: {
        step1: '프로젝트 정보 입력',
        step2: '주문 정보 확인',
      },
      message: {
        success: '생성 성공',
        videoDurationOver60s: '비디오 길이가 {{max}}초를 초과합니다',
        videoDurationLessThan10s: '비디오 길이가 {{min}}초 미만입니다',
        videoDurationNeedOver10s: '동영상 길이는 10초를 초과해야 합니다',
        videoDurationNeedWithin5To10s: '동영상 길이는 5초에서 10초 사이여야 합니다',
        videoDurationNotMatchDurationCategory: '현재 동영상 길이는 해당 프로젝트 유형의 테스트 요건을 충족하지 않습니다. 동영상을 다시 업로드한 후 다시 시도해 주세요.',
        videoUploadingCannotSwitchDurationCategory: '동영상 업로드 중에는 크리에이티브 유형을 전환할 수 없습니다. 업로드가 완료될 때까지 기다려 주세요.',
        videoFormatOrDurationError: '동영상 형식 또는 길이를 읽을 수 없습니다. 동영상 파일을 확인한 후 다시 시도해 주세요.',
        videoSizeOver200M: '비디오 크기가 256MB를 초과합니다',
        videoLandscape: '비디오는 가로 화면이어야 합니다',
        videoPortrait: '동영상은 세로형이어야 합니다',
        clickToUploadTestVideo: '테스트 비디오를 업로드하려면 클릭하세요',
        uploadFailed: '업로드에 실패했습니다. 다시 업로드하세요',
        uploadDesc1: '가로 화면 비디오 파일을 지원, 형식은 MP4, MOV',
        uploadDescPortrait: 'MP4, MOV 형식의 세로형 동영상 파일을 지원합니다',
        uploadDesc2: '기타 형식, 파일 크기 제한은 256MB 까지',
        formNotCompleted: '모든 정보를 입력하세요',
        uploadAdVideo: '광고 비디오를 업로드하세요',
        inputInvalid: '입력 내용이 유효하지 않습니다',
        insufficientTestPoints: '현재 테스트 포인트가 부족합니다. 충전 후 다시 시도하십시오.',
        reviewProjectInfo:
          '프로젝트 정보를 잘 확인하세요. 한 번 주문이 확인되면 변경할 수 없습니다.',
        waitingDesc:
          '최대 3개의 프로젝트를 동시에 분석할 수 있습니다. 이 프로젝트는 대기 큐에 들어갔으며, 곧 자동으로 분석을 시작합니다.',
        ageRangeInvalid: '나이 범위는 20-55만 지원합니다',
        normDesc: '무제한 저작권 혜택, 기업이 자체 기준값을 설정할 수 있습니다',
      },
    },
    projectDetailPage: {
      testResults: '테스트 결과',
      share: '공유',
      shareFailed: '공유에 실패했습니다',
      shareModal: {
        title: '공유',
        desc: '아래 텍스트를 복사해 소셜 미디어에 공유하세요.',
        saveImage: '이미지 저장',
        copyText: '텍스트 복사',
        copySuccess: '복사되었습니다',
        copyFailed: '복사에 실패했습니다',
        textTemplate:
          '와우! 제 AI 크리에이티브가 AdEff에서 유사 작품의 {{score}}%를 앞섰어요! 진짜 실력은 데이터가 증명합니다. AdEff AI 크리에이티브 테스트는 지금 무료입니다. {{hostname}}에서 점수를 확인해 보세요. 무료 테스트 5회를 받고, 멋진 평가를 받으시길 바랍니다!',
      },
      sharePoster: {
        createdByYou: '당신이 만든 작품',
        scoreTemplate: 'AIGC 크리에이티브의 <score>{{score}}</score>를 앞섰습니다',
        statsAt: '집계 시각 ',
        certification: '크리에이티브 인증',
        footerText: '계속 창작하여 더 많은 우수한 작품을 만들어 주세요!',
      },
      basicInformation: '기본 정보',
      waiting: '대기 중',
      ongoing: '진행 중',
      failed: '실패',
      tryAgain: '다시 시도',
      videoAnalysisFailed: '비디오 분석에 실패했습니다',
      message: { projectNotFound: '프로젝트를 찾을 수 없습니다' },
      primaryAnalysis: '주요 성과',
      detailAnalysis: '상세 분석',
      heatmapAnalysis: '히트맵',
      analysisStepDesc: 'AI는 모든 분석 작업을 완료했습니다. 상세 분석은 다음과 같습니다',
      analysisWaitingDesc:
        '최대 3개의 프로젝트를 동시에 분석할 수 있습니다. 이 프로젝트는 대기 큐에 들어갔으며, 곧 자동으로 분석을 시작합니다',
      aiTip: '보고서 내용은 AI에 의해 생성되었으며 참고용으로만 제공됩니다',
      subAnalysisDescription: {
        adVideoScore: '광고 효과 지수',
        adVideoScoreDesc:
          '광고 효과 지수는 광고의 단기 및 장기 판매 효과를 예측하는 데 사용되는 종합 지표입니다.',
        norm: '기준값',
        normDesc: '산업 또는 역사 데이터의 기준값으로, 광고 성과의 수평 비교에 사용됩니다.',
        attentionIndex: '주의 지수',
        attentionIndexDesc:
          '오디언스의 시각적 주의가 집중된 상황을 반영하며, 광고의 장면이나 요소가 시청을 끌어당기는 능력을 나타냅니다.',
        emotionIndex: '감정 지수',
        emotionIndexDesc:
          '오디언스의 긍정적인 감정이 자극되는 정도를 반영하며, 광고에 의해 유발되는 즉각적인 감정의 변동을 나타냅니다.',
        cognitionIndex: '인지 지수',
        cognitionIndexDesc:
          '오디언스의 인지 처리 정도를 반영하며, 광고 내용에 대해 얼마나 생각했는지를 나타냅니다.',
        theGolden3Seconds: '황금의 3초',
        theGolden3SecondsDesc: '광고의 처음 3초는 광고의 성공을 결정하는 중요한 순간입니다.',
        informationTransmission: '정보의 순간',
        informationTransmissionDesc:
          '광고 정보의 순간이 타겟 오디언스의 주의를 끌고 흥미를 자극하는 능력을 측정합니다.',
        brandRelevance: '브랜드의 순간',
        brandRelevanceDesc:
          '브랜드의 순간이 타겟 오디언스의 주의를 끌고 흥미를 자극하는 능력을 측정합니다.',
        interestStimulation: '흥미의 순간',
        interestStimulationDesc:
          '오디언스의 감정적 공명과 능동적 인지를 유도하는 중요한 내용의 순간입니다.',
        theEnding3Seconds: '결말의 3초',
        theEnding3SecondsDesc:
          '피크엔드 법칙에 따라 광고의 마지막 3초는 시청자의 주의를 강화하고 정보 전달을 강화하는 중요한 순간입니다.',
      },
      infoDrawer: {
        basicInformation: '기본 정보',
        advertisingInformation: '광고 정보',
        projectName: '프로젝트 이름',
        brandName: '브랜드 이름',
        category: '산업',
        norm: '타겟 시장 기준값',
        normLabel: '기준값',
        brandNorm: '브랜드 기준값',
        adName: '광고 이름',
        taGender: 'TA 성별',
        targetMarket: '타겟 시장',
        taAge: 'TA 나이',
        ageRange: '{{start}} 세에서 {{end}} 세까지',
        modify: '수정',
        cancel: '취소',
        confirm: '확인',
      },
      videoView: {
        eyeMovementRatio: '주의 지수',
        cognitiveEngagement: '인지 지수',
        emotionRecognition: '감정 지수',
        subjectiveResponseCurve: '주관적 반응 곡선',
        realtimeData: '실시간 데이터',
        panoramicData: '파노라마 데이터',
        indexAnalysis: '지표 분석',
        advantage: '장점',
        disadvantage: '단점',
        suggestions: '제안',
        adVideoScore: '광고 효과 지수',
        norm: '기준값',
        analysisStepTitle1: '콘텐츠 디코딩',
        analysisStepTitle2: '피드백 예측',
        analysisStepTitle3: '데이터 통합',
        analysisStepTitle4: '결론 추론',
        analysisStepDesc1:
          '광고 콘텐츠의 다중 모달 디코딩을 시작하고, 시각, 음성, 텍스트, 구조를 디코딩합니다...',
        analysisStepDesc2:
          '오디언스의 주관적 반응을 예측하고, 광고의 초 단위 내용에 기반하여 오디언스의 시선과 뇌파 데이터를 예측합니다...',
        analysisStepDesc3: '광고의 객관적 내용과 오디언스의 주관적 반응 데이터를 통합합니다...',
        analysisStepDesc4: '추론 모델에 기반하여 평가 결론과 행동 제안을 생성합니다...',
        keyResult: '핵심 결과',
        videoChart: {
          videoFailed: '비디오 재생에 실패했습니다',
          videoFailedAction: '다시 시도하세요. 문제가 지속되면 지원 센터에 문의하세요.',
        },
      },
      storyboardView: {
        summary: '요약',
        advantages: '장점',
        disadvantages: '단점',
        suggestions: '제안',
        keyResult: '핵심 결과',
        norm: '기준값',
        theGolden3Seconds: '황금의 3초',
        informationTransmission: '정보의 순간',
        brandRelevance: '브랜드의 순간',
        interestStimulation: '흥미의 순간',
        theEnding3Seconds: '결말의 3초',
      },
      heatmapView: {},
    },
    accountPage: {
      email: '이메일',
      username: '사용자 이름',
      password: '비밀번호',
      setPasswordToEnableEmailLogin: '이메일 로그인을 활성화하려면 비밀번호를 설정하세요',
      uid: 'UID',
      contactAndReceiveNotifications: '연락하여 알림을 받기',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        '이 이메일 주소로 AdEff의 최신 업데이트에 대한 이메일을 받습니다.',
      myWorkspace: '내 작업 공간',
      newRequest: '새 요청',
      invitationCode: '추천 코드',
      userName: '사용자 이름',
      invitationCodeDesc:
        '각 팀에는 새로운 사용자가 등록 중에 팀에 참여하기 위한 고유한 초대 코드가 있습니다',
      table: {
        userName: '사용자 이름',
        email: '이메일',
        operation: '작업',
        admin: '관리자',
        remove: '삭제',
        deny: '거부',
        approve: '승인',
      },
      message: {
        yourTeamIsFull: '귀하의 팀은 가득 찼습니다. 추가 멤버를 얻으려면 문의하세요.',
        invitationLinkSent: '초대 링크가 이 이메일 주소로 전송되었습니다!',
        removeReminder: '삭제 알림',
        remove: '삭제',
        removeMember:
          '멤버를 삭제하면 해당 멤버가 생성한 콘텐츠는 유지됩니다. 멤버를 삭제하시겠습니까?',
        removeMemberSuccess: '멤버 삭제 성공!',
        ok: '확인',
        contactUs: '문의하기',
        applicationProcessedSuccessfully: '신청이 성공적으로 처리되었습니다!',
        notificationSettingsTurnedOn: '알림 설정이 켜졌습니다',
        notificationSettingsTurnedOff: '알림 설정이 꺼졌습니다',
        setPassword: '비밀번호 설정',
        passwordConfirm: '확인',
        passwordCancel: '취소',
        oldPassword: '이전 비밀번호',
        newPassword: '새 비밀번호',
        pleaseEnterTheOldPassword: '이전 비밀번호를 입력하세요',
        pleaseEnterTheNewPassword: '새 비밀번호를 입력하세요',
        incorrectEntryOfOriginalPassword: '원래 비밀번호 입력 오류',
        passwordUpdatedSuccessfully: '비밀번호가 성공적으로 업데이트되었습니다',
        changeUsername: '사용자 이름 변경',
        confirm: '확인',
        cancel: '취소',
        username: '사용자 이름',
        pleaseEnterTheNewUsername: '새 사용자 이름을 입력하세요',
        userNameUpdatedSuccessfully: '사용자 이름이 성공적으로 업데이트되었습니다',
        addMemberToWorkspace: '작업 공간에 새 멤버 추가',
        notAdminOperate: '관리자가 아니므로 작업할 수 없습니다',
        emailAddress: '이메일 주소',
        send: '전송',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          '이 주소로 확인을 위한 초대 이메일을 전송합니다.',
        workspaceMemberShip: '작업 공간 멤버십',
        forMoreMembership: '더 많은 멤버십',
        reachedTheCeiling: '인원이 한계에 도달했습니다.',
        incorrectMailboxFormat: '이메일 형식이 올바르지 않습니다',
        member: '멤버',
        changeCorpNameTitle: '회사 이름 변경',
        changeCorpNameLabel: '회사 이름',
        pleaseEnterTheCorpName: '회사 이름을 입력하세요',
        changeCorpNameSuccess: '회사 이름이 성공적으로 변경되었습니다',
        changeCorpNameFailed: '회사 이름 변경에 실패했습니다',
        noPermission: '회사 이름 변경 권한이 없습니다',
      },
    },
    subscriptionPage: {
      currentPlan: '현재 플랜',
      getInvoice: '청구서 받기',
      remainingTimes: '남은 횟수',
      purchaseMore: '더 구매하기',
      contactUs: '문의하기',
      teamPlan: '전문가 팀 서비스',
      unlimited: '무제한',
      dueDate: '만료일',
      table: {
        usageRecords: '사용 기록',
        date: '날짜',
        projectName: '프로젝트 이름',
        projectType: '프로젝트 유형',
        usageCount: '회',
        userName: '사용자 이름',
        noRelevantContent: '관련 콘텐츠를 찾을 수 없습니다',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: '일반 크리에이티브 프로젝트',
      regularCreative: '일반 크리에이티브',
      splashCreativeProject: '스플래시 크리에이티브 프로젝트',
      splashCreative: '스플래시 크리에이티브',
      projects: '프로젝트 수',
      localNorm: '로컬 벤치마크',
      projectPassRate: '프로젝트 통과율',
      passRate: '통과율',
    },
    dataDetailPage: {
      baseData: '기본 데이터',
      totalProjects: '총 프로젝트 수',
      totalProjectsDesc: '광고 효과 평가에 참여한 모든 유효한 프로젝트의 총 수입니다.',
      // averageEffectivenessIndex: '평균 광고 효과 지수',
      // averageEffectivenessIndexDesc: '모든 유효한 프로젝트의 광고 효과 지수의 평균입니다.',
      localNormProjects: '타겟 시장 기준값 프로젝트',
      brandNormProjects: '브랜드 기준값 프로젝트',
      normProject: '타겟 시장 기준값 프로젝트',
      brandNormProject: '브랜드 기준값 프로젝트',
      localNorm: '타겟 시장 기준값',
      localNormDesc:
        '귀하가 거주하는 국가를 타겟 시장으로 하는 유효한 광고 프로젝트의 광고 효과 지수 평균값입니다.',
      norm: '기준값',
      brandNorm: '브랜드 기준값',
      brandNormDesc:
        '귀하가 설정한 브랜드 기준값을 사용한 유효한 광고 프로젝트의 광고 효과 지수 평균값입니다.',
      localProjectPassRate: '타겟 시장 프로젝트 통과율',
      projectPassRate: '프로젝트 통과율',
      brandProjectPassRate: '브랜드 프로젝트 통과율',
      projectPassRateDesc:
        '모든 프로젝트의 광고 효과 지수가 기준값을 초과한 프로젝트의 비율입니다.',
      advertisingEffectivenessIndexDistribution: '광고 효과 지수 분포',
      advertisingEffectivenessIndexDistributionDesc: '광고 효과 지수의 분포입니다.',
      item: '항목',
    },
    dataComparisonPage: {
      createCompare: '새 비교',
      createCompareDesc: '여러 프로젝트를 선택해 비교할 수 있으며 최대 10개까지 선택할 수 있습니다.',
      startCompare: '비교 시작',
      compareReport: '비교 보고서',
      searchPlaceholder: '비교 보고서 이름 검색',
      emptyText: '아직 비교 보고서가 없습니다. 먼저 비교할 프로젝트를 선택하세요.',
      searchEmptyText: '비교 보고서를 찾을 수 없습니다.',
      deleteTitle: '비교 보고서 삭제',
      deleteConfirm: '이 비교 보고서를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
      projectCount: '{{count}}개 프로젝트',
    },
    dataComparisonStartPage: {
      back: '뒤로',
      basicInfo: '기본 정보',
      reportName: '보고서 이름:',
      reportNamePlaceholder: '비교 보고서 이름 입력',
      norm: '벤치마크:',
      normPlaceholder: '벤치마크 선택',
      normTip: '프로젝트 비교에 사용할 벤치마크를 선택하세요',
      selectProject: '프로젝트 선택',
      searchPlaceholder: '프로젝트/광고/브랜드명으로 검색',
      selectedCountPrefix: ' 선택됨 ',
      selectedCountSuffix: '개 프로젝트, 최대 {{max}}개 프로젝트',
      startCompare: '비교 시작',
      save: '저장',
      cancel: '취소',
      maxSelectedWarning: '최대 10개 프로젝트까지 선택할 수 있습니다',
      reportNameRequired: '비교 보고서 이름을 입력하세요',
      normRequired: '벤치마크를 선택하세요',
      projectRequired: '프로젝트를 선택하세요',
    },
    dataComparisonInfoPage: {
      defaultReportName: '비교 보고서 이름',
      reportNotFound: '보고서를 찾을 수 없습니다',
      back: '뒤로',
      modify: '수정',
      deletedProjectTip: '다음 프로젝트: {{names}} 이(가) 삭제되었습니다. 확인 후 비교 보고서가 업데이트되고 삭제된 프로젝트가 제거됩니다.',
      confirmDeletedProjects: '확인',
      metricScore: '지표 점수',
      tabDimension: '5대 차원',
      tabMoment: '핵심 순간',
      tabAttitude: '소비자 태도',
      adeffScore: 'AdEff 점수',
      brandName: '브랜드 이름',
      projectName: '프로젝트 이름',
      industry: '업종',
      targetMarket: '타깃 시장',
      gender: 'TA 성별',
      age: 'TA 연령',
      adProject: '광고 프로젝트',
      normLabel: '벤치마크',
      mixedCreativeBenchmarkTip: '일반 소재와 스플래시 소재를 동시에 비교할 때는 벤치마크가 없습니다.',
      emptyProject: '비교 데이터를 보려면 프로젝트를 선택하세요',
      viewProjectDetail: '프로젝트 상세 보기',
      listSeparator: ', ',
      metricLabels: {
        attention: '주의력',
        infectivity: '감정력',
        delivery: '메시지 힘',
        brand: '브랜드 힘',
        persuasion: '설득력',
        gazeRecognition: '시선 인식',
        emotionRecognition: '감정 인식',
        engagementRecognition: '몰입 인식',
        goldenSeconds: '황금의 3초',
        brandMoment: '브랜드의 순간',
        productMoment: '흥미의 순간',
        messageMoment: '정보의 순간',
        endingSeconds: '결말의 3초',
        likeability: '호감도',
        newInformation: '새로운 정보',
        messageRelevance: '메시지 관련성',
        comprehension: '이해도',
        credibility: '신뢰도',
        brandLinkage: '브랜드 연결성',
        uniqueness: '독창성',
        learnMoreIntent: '더 알아볼 의향',
        purchaseIntent: '구매 의향',
        recommendIntent: '공유 의향',
        brandLikeabilityLift: '브랜드 호감도 상승',
        purchaseIntentionLift: '구매 의향 상승',
        attentionIndex: '주의 지수',
        emotionIndex: '감정 지수',
        cognitionIndex: '인지 지수',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'TVC 크리에이티브 평가 프로젝트가 완료되었습니다.',
        title: {
          text1: '광고 크리에이티브 테스트',
          text2: '테스트 보고서',
        },
        flowAnalysis: {
          desc1: 'AdEff가 동영상 광고를 분석하고 있습니다',
          desc2: '동영상 분석이 완료되었습니다',
          desc3: '소비자의 시각적 주의를 분석하고 있습니다',
          desc4: '소비자 프로필을 기반으로 시각적 초점을 분석하고 있습니다',
          desc5: '주의 히트맵을 생성하고 있습니다',
          desc6: '동적 히트맵이 생성되었습니다',
          desc7: '인지-신경 반응을 측정하고 있습니다',
          desc8: '시선, 감정, 몰입도를 초 단위로 추적하고 있습니다',
          desc9: '신경 반응 곡선을 생성하고 있습니다',
          desc10: '신경 반응 곡선이 생성되었습니다',
          desc11: '핵심 순간의 성과를 분석하고 있습니다',
          desc12: '골든 3초, 메시지 순간, 브랜드 순간, 관심 피크, 마지막 3초 동안의 인지-신경 반응을 측정하고 있습니다',
          desc13: '핵심 순간 지표를 종합하고 있습니다',
          desc14: '핵심 순간 분석이 완료되었습니다',
          desc15: '소비자 태도를 분석하고 있습니다',
          desc16: '브랜드, 제품, 콘텐츠에 대한 태도를 분석하고 있습니다',
          desc17: '태도 지표를 종합하고 있습니다',
          desc18: '태도 지표가 완료되었습니다',
          desc19: '5가지 동인 점수를 생성하고 있습니다',
          desc20: '5가지 동인 점수가 준비되었습니다',
          desc21: '분석 완료! 광고 성과 보고서가 준비되었습니다',
          terminology: {
            thumbExpand: '썸네일 펼치기',
            thumbCollapse: '썸네일 접기',
            gazeRecognition: '시선 인식',
            gazeRecognitionDesc: '시각적 주의 집중도를 측정하여 광고 요소가 시청자의 초점을 얼마나 효과적으로 사로잡는지 보여줍니다.',
            emotionRecognition: '감정 인식',
            emotionRecognitionDesc: '광고가 유발한 긍정적 감정과 즉각적인 정서 반응을 정량화합니다.',
            engagementRecognition: '몰입 인식',
            engagementRecognitionDesc: '광고 콘텐츠에 대한 정신적 투입을 반영하는 몰입도와 참여도를 측정합니다.',
            theGolden3Seconds: '골든 3초 성과',
            theGolden3SecondsDesc: '광고 첫 3초 동안 콘텐츠의 효과를 평가합니다.',
            keyMessage: '핵심 메시지 성과',
            keyMessageDesc: '광고 정보 순간이 주의를 사로잡고 관심을 자극하는 능력을 측정합니다.',
            brand: '브랜드 성과',
            brandDesc: '브랜드 특화 주의 포착과 참여 효과를 평가합니다.',
            interest: '관심 피크',
            interestDesc: '감정적 공감과 높은 몰입을 유발하는 콘텐츠 피크를 식별합니다.',
            ending3Seconds: '마지막 3초 성과',
            ending3SecondsDesc: '광고 마지막 3초 동안 콘텐츠의 효과를 평가합니다.',
            score: '점수',
            benchmark: '벤치마크',
            metrics: '지표',
            attitudePart: {
              attitudeMetrics: '태도 지표',
              liking: '호감도',
              likingDesc: '광고에 대한 시청자의 주관적 태도와 전반적인 호감도를 측정합니다.',
              newInformation: '새로운 정보',
              newInformationDesc: '시청자가 광고를 통해 브랜드 또는 제품에 대한 이전에 알지 못했던 가치 있는 정보를 얻었다고 느끼는지 측정합니다.',
              messageRelevance: '메시지 관련성',
              messageRelevanceDesc: '광고가 전달한 정보가 자신과 직접 관련 있다고 시청자가 인식하는 정도를 측정합니다.',
              comprehension: '이해도',
              comprehensionDesc: '광고의 핵심 메시지가 명확하고 정확하며 쉽게 이해되었는지 측정합니다.',
              credibility: '신뢰도',
              credibilityDesc: '광고가 전달한 정보가 사실이고 신뢰할 수 있다고 시청자가 믿는 정도를 측정합니다.',
              brandLinkage: '브랜드 연결성',
              brandLinkageDesc: '시청자가 광고 내용을 특정 브랜드와 정확하고 강하게 연결할 수 있는지 측정합니다.',
              uniqueness: '독창성',
              uniquenessDesc: '광고가 경쟁사 대비 브랜드의 뚜렷하고 가치 있는 독창성을 명확히 인식시키는지 측정합니다.',
              willing: '더 알아볼 의향',
              willingDesc: '광고 시청 후 브랜드나 제품에 대해 더 알아보기 위해 적극적으로 행동할 주관적 가능성을 측정합니다.',
              purchase: '구매 의향',
              purchaseDesc: '광고 시청 후 향후 브랜드 제품을 선택하거나 구매할 것을 고려할 주관적 가능성을 측정합니다.',
              share: '공유 의향',
              shareDesc: '광고 시청 후 광고나 브랜드 정보를 다른 사람과 적극적으로 공유할 주관적 가능성을 측정합니다.',
              brandLikeLift: '브랜드 호감도 상승',
              brandLikeLiftDesc: '광고 노출 후 브랜드 또는 제품에 대한 전반적 호감도가 어떤 방향과 정도로 변화했는지 측정합니다.',
              purchaseIntentLift: '구매 의향 상승',
              purchaseIntentLiftDesc: '광고 노출 후 브랜드 제품 구매 고려 의향이 어떤 방향과 정도로 변화했는지 측정합니다.',
            },
            dimensionPart: {
              forceDrives: '동인 지표',
              attension: '주의력',
              emotionalImpact: '감정적 영향',
              messageClarity: '메시지 명확성',
              brandPower: '브랜드 파워',
              persuasion: '설득력',
              attentionForce: '주의력',
              attentionForceDesc: '광고가 시청자의 시각 및 청각 주의를 끌고 유지하는 능력을 측정합니다.',
              emotionalForce: '감정력',
              emotionalForceDesc: '광고 콘텐츠가 유발하는 즉각적이고 본능적인 감정 공감과 감정 변동의 강도를 측정합니다.',
              messageForce: '메시지 힘',
              messageForceDesc: '광고의 핵심 메시지가 대상 시청자에게 명확히 식별되고 정확히 이해되며 깊게 기억되는 효과를 측정합니다.',
              brandForce: '브랜드 힘',
              brandForceDesc: '광고가 브랜드 정체성을 강화하고 브랜드 호감도를 높이며 강한 브랜드 연결을 형성하는 효과를 측정합니다.',
              persuasiveForce: '설득력',
              persuasiveForceDesc: '광고가 인식을 변화시키고 행동 의향을 유도하는 최종 전환 능력을 측정합니다.',
            },
            result: {
              results: '결과',
              pass: '통과',
              notPass: '미통과',
              adeffScore: 'AdEff 점수',
              adeffScoreDesc: 'AdEff 점수는 광고의 전반적인 효과를 측정하기 위한 지표입니다.',
              benchmarkDesc: '광고가 위치한 국가 또는 지역의 모든 업로드 광고 평균 AdEff 점수를 기준으로 해당 광고의 성과를 비교합니다.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: '대기 중...',
            description: '테스트 보고서를 생성하고 있습니다...',
          },
          generating: '생성 중...',
          freeTrialLockText1: '체험 모드에서는 전체 보고서를 미리 보거나 다운로드할 수 없습니다.',
          freeTrialLockText2: '구독하면 잠금 해제됩니다.',
        },
      },
    },
  },
  professor: {
    account: '계정',
    password: '비밀번호',
    login: '로그인',
    expertReviews: '전문가 평가',
    adVideoScore: '광고 효과 지수',
    subjectiveResponseCurve: '주관적 반응 곡선',
    indexAnalysis: '지표 분석',
    keyResult: '핵심 결과',
    theGolden3Seconds: '황금의 3초',
    informationTransmission: '정보의 순간',
    brandRelevance: '브랜드의 순간',
    interestStimulation: '흥미의 순간',
    theEnding3Seconds: '결말의 3초',
    heatMap: '히트맵',
    suggestion: '제안',
    suggestion1: '제안',
    submit: '제출',
    next: '다음',
    summary: '요약',
    advantages: '장점',
    disadvantages: '단점',
    option1: '예상',
    option2: '예상 외',
    resultJudgment: '평가',
    placeholder: '제안을 입력하세요',
    waitRateCount: '평가 대기 광고 수',
    unfinishedTitle: '주의',
    unfinishedRate: '현재 프로젝트에 평가되지 않은 콘텐츠가 있습니다. 계속하시겠습니까?',
    unfinishedConfirm: '계속',
    unfinishedCancel: '취소',
    message: {
      submitSuccess: '평가에 감사합니다',
      submitSuccess1: '현재 프로젝트의 평가를 완료했습니다. 평가에 감사합니다',
      loginSuccess: '로그인 성공',
      rateUnfinished: '현재 내용을 아직 평가하지 않았습니다. 작성 후 다음 질문으로 넘어가세요',
      rateLocation: '평가되지 않은 콘텐츠로 자동으로 이동했습니다',
    },
  },
  modals: {
    freeTrialModal: {
      title: '프리 트라이 신청',
      title1: '무료 트라이',
      trial: '프리 트라이',
      hiddenBoxText1: '여러 장점, 단점, 제안이 발견되었습니다',
      hiddenBoxText2: '전체 보고서를 얻으려면 구독하세요',
      hiddenBoxBtn: '지금 구독하기',
      applyBox: {
        name: '이름',
        tel: '연락처',
        department: '부서',
        role: '역할',
        country: '국가',
        city: '도시',
        pleaseEnter: '입력하세요',
        pleaseSelect: '선택하세요',
        pleaseEnterTheName: '이름을 입력하세요',
        pleaseEnterTheTel: '연락처를 입력하세요',
        pleaseEnterValidTel: '유효한 연락처를 입력하세요',
        pleaseEnterValidEmail: '유효한 이메일을 입력하세요',
        pleaseSelectTheDepartment: '부서를 선택하세요',
        pleaseSelectTheRole: '역할을 선택하세요',
        pleaseSelectTheCountry: '국가를 선택하세요',
        pleaseEnterTheCity: '도시를 입력하세요',
        textIsRequired: '이 필드는 필수입니다',
        submit: '제출',
        tip: '각 기업은 무료 트라이 기회가 한 번만 있습니다',
      },
      gotTrial: '프리 트라이를 받았습니다!',
      goPc: '프로젝트를 만들려면 PC 웹 버전에 접속하세요.',
      back: '뒤로가기',
      country: {
        China: '중국',
        Japan: '일본',
        Korea: '한국',
        Indonesia: '인도네시아',
        Thailand: '태국',
        Singapore: '싱가포르',
        Malaysia: '말레이시아',
        Vietnam: '베트남',
        Germany: '독일',
        Britain: '영국',
        France: '프랑스',
        Italy: '이탈리아',
        Russia: '러시아',
        Spain: '스페인',
        Turkey: '터키',
        America: '미국',
        Canada: '캐나다',
        Brazil: '브라질',
        Other: '기타',
      },
      department: {
        Brand: '브랜드',
        Market: '마케팅',
        Marketing: '마케팅',
        IT: 'IT',
        Procurement: '구매',
        Other: '기타',
      },
      role: {
        President: '대표/부대표/총괄 매니저',
        CMO: 'CMO 또는 기타 C-레벨 관리',
        Director: '부서 책임자',
        Manager: '부서 매니저',
        Other: '기타',
      },
      message: {
        submitSuccess: '평가에 감사합니다',
        submitFailed: '평가에 실패했습니다. 다시 시도하세요.',
      },
    },
    downloadPptRechargeModal: {
      title: '다운로드할 수 없습니다',
      desc1: '체험판에서는 다운로드할 수 없습니다',
      desc2: '구독 후 전체 보고서를 다운로드할 수 있습니다',
      btn: '지금 구독하기',
    },
    checkInvitationCodeModal: {
      invitationCode: '추천 코드',
      invitationCodeDesc1: '추천 코드는 변경할 수 없습니다. 변경하려면 문의하세요',
      invitationCodeDesc2: '에이전트 추천을 통해 이용하시는 경우 추천 코드를 입력해 주세요',
      invitationCodePlaceholder: '추천 코드를 입력하세요',
      invitationCodeError: '유효하지 않은 추천 코드입니다',
      invitationCodeSuccess: '추천 코드가 성공적으로 변경되었습니다',
      ok: '확인',
      cancel: '취소',
    },
    aigcPromotionModal: {
      title: 'AIGC 크리에이터 혜택',
      subTitle: '지금 가입하고 <tmp>5</tmp>회의 AI 영상 평가 기회를 받으세요',
      desc1: '크리에이티브를 평가하려면 AdEff AI 크리에이티브 테스트 이벤트에 참여하세요.',
      desc2: '지금 가입하고 무료 테스트 5회를 즉시 받으세요.',
      registerBtn: '가입하고 테스트 기회 받기',
      tip: 'AIGC 크리에이터 캠페인 입구를 통해 가입한 신규 사용자에게만 제공',
      floatTitle: '무료 테스트',
    },
  },
}

export default TRANSLATION
